import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function SocialProofSection() {
  const testimonials = [{
    quote: 'We used to miss calls constantly. Now we wake up to booked appointments instead of voicemails.',
    author: 'Local Business Owner'
  }, {
    quote: 'I was skeptical about AI answering my phones, but Jessica sounds natural and my clients love it.',
    author: 'Home Services Contractor'
  }, {
    quote: 'Best investment we made this year. Pays for itself in the first week.',
    author: 'Real Estate Agent'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-162">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative" data-id="element-163">
              <QuoteIcon className="w-8 h-8 text-viridia-200 absolute top-6 left-6 -z-10" data-id="element-164" />
              <div className="flex gap-1 mb-4" data-id="element-165">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-166" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-167">
                "{item.quote}"
              </p>
              <p className="text-sm font-bold text-gray-900 uppercase tracking-wide" data-id="element-168">
                {item.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}